module.exports = __webpack_public_path__ + "./fonts/GalanoGrotesqueAlt-Regular.ttf";